import { render, staticRenderFns } from "./ImagesDetails.vue?vue&type=template&id=2861b456&"
import script from "./ImagesDetails.vue?vue&type=script&lang=js&"
export * from "./ImagesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports